import * as React from 'react';
import { Button } from '@cian/ui-kit';

export interface IMapButtonProps {
  onClick(): void;
}

export const MapButton = ({ onClick }: IMapButtonProps): React.JSX.Element => (
  <Button data-testid="newbuildings-map-button" size="XS" theme="main_secondary" onClick={onClick}>
    Все ЖК на карте
  </Button>
);
